import purpleTshirt from '../../assets/images/yeti_page/purple.jpg'
import whiteTshirt from '../../assets/images/yeti_page/white.jpg'
import VueRecaptcha from 'vue-recaptcha'

export default {
  name: 'ItemPage',
  props: {
    componentClass: {type: String, default: ''}
  },
  components: { VueRecaptcha },
  data: function () {
    return {
      sitekey: process.env.CAPTCHA_KEY,
      images: {
        purple: {
          url: purpleTshirt,
          alt: 'Example of purple T-shirt'
        },
        white: {
          url: whiteTshirt,
          alt: 'Example of white T-shirt'
        }
      },
      showOrder: true,
      status: '',
      order: {
        title: 'T-shirt Request',
        name: '',
        address: '',
        zipcode: '',
        state: '',
        email: '',
        company: '',
        style: '',
        size: '',
        gender: '',
        message: ''
      }
    }
  },
  methods: {
    getItemStyleUrl: function () {
      if (this.order.style !== '') {
        return this.images[this.order.style].url
      }
    },
    getItemStyleAlt: function () {
      if (this.order.style !== '') {
        return this.images[this.order.style].alt
      }
    },
    submit: function () {
      this.$refs.recaptcha.execute()
    },
    onCaptchaExpired: function () {
      this.$refs.recaptcha.reset()
    },
    onCaptchaVerified: function (recaptchaToken) {
      const self = this
      self.status = 'submitting'
      self.$refs.recaptcha.reset()
      this.handleSubmitForm(recaptchaToken)
    },
    handleSubmitForm: function (recaptchaToken) {
      // Build the request body from the mock data.
      let formDataVar = new FormData()
      formDataVar.append('recaptchaToken', recaptchaToken)
      for (let property in this.order) {
        if (this.order.hasOwnProperty(property)) {
          formDataVar.append(property, this.order[property])
        }
      }
      this.sendFormFields(process.env.AWS_SES_URL, formDataVar)
    },
    sendFormFields: function (url, messageContent) {
      fetch(url, {
        method: 'post',
        body: messageContent
      }).then((response) => {
        if (response.ok) {
          this.showOrder = false
        } else {
          console.log('error')
        }
      })
    }
  },
  mounted () {
    let recaptchaScript = document.createElement('script')
    recaptchaScript.setAttribute('src', 'https://www.google.com/recaptcha/api.js?onload=vueRecaptchaApiLoaded&render=explicit')
    document.head.appendChild(recaptchaScript)
  }
}



// WEBPACK FOOTER //
// ./src/components/ItemPage/ItemPage.js